// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBOjOA6...",
  authDomain: "ingrov-system.firebaseapp.com",
  projectId: "ingrov-system",
  storageBucket: "ingrov-system.appspot.com",
  messagingSenderId: "645848130655",
  appId: "1:645848130655:web:d2adc5f3a2e87cb38fe7ea",
  measurementId: "G-LEV0SNE3KL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db };

console.log("Firebase initialized:", app);
console.log("Rendering the React app...");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log("The app rendered successfully!");